module.exports = __webpack_public_path__ + "img/wedo_pict02.d95ec472.png";